import { createStore as reduxCreateStore, applyMiddleware } from 'redux'
import { handleActions } from 'redux-actions'
import { composeWithDevTools } from 'redux-devtools-extension'

import * as types from './actionTypes'

const initialState = { 
  remarkScreen: {
    isActive: false
  },
}

const reducer = handleActions({
  [types.TOGGLE_REMARK_SCREEN]: (state) => Object.assign({}, state, {
    remarkScreen: {
      isActive: !state.remarkScreen.isActive
    }
  })
}, initialState)

const createStore = () => reduxCreateStore(
  reducer, 
  initialState, 
  composeWithDevTools(applyMiddleware())
)
export default createStore



// WEBPACK FOOTER //
// ./src/state/createStore.js